<template>
    <div class="container col-md-8 offset-md-2 mt-5">
        <span hidden="dn">{{  changer }}</span>
        <div class="card p-3 mb-3 card-lg shadow steps-card">
            <div class="container text-black">
                <div class="text-left my-3 font-25px steps-title">
                    {{ $t("business_idea") }}
                </div>

                <!-- Start card content -->
                <div>
                    <div class="form-row">
                        <div class="col-lg-12 form-group">
                            <input
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': $v.projectInfo.name.$error
                                }"
                                :placeholder="$t('project_name') + ' *'"
                                onfocus="this.placeholder=''"
                                onblur="this.placeholder='Nome del progetto *'"
                                @focus="showHideLabel('name')"
                                @blur="showHideLabel('name')"
                                v-model.trim="$v.projectInfo.name.$model"
                                required
                            />
                            <small
                                id="name_label"
                                style="display: none"
                                class="mt-2"
                                >{{ $t("project_name") }} *</small
                            >
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 form-group">
                            <select
                                class="custom-select form-control"
                                :class="{
                                    'is-invalid': $v.projectInfo.sector.$error
                                }"
                                @focus="showHideLabel('sector')"
                                @blur="showHideLabel('sector')"
                                v-model.trim="$v.projectInfo.sector.$model"
                                required
                            >
                                <option
                                    :value="null"
                                    selected
                                    disabled
                                    class="custom-select-placeholder"
                                >
                                    {{ $t("sector") }} *
                                </option>
                                <option
                                    v-for="option in sectorSelect.options"
                                    :value="option.option_ita"
                                    :key="option.option_ita"
                                >
                                    {{ option.option }}
                                </option>
                            </select>
                            <small
                                id="sector_label"
                                style="display: none"
                                class="mt-2"
                                >{{ $t("sector") }} *</small
                            >
                        </div>
                        <div class="col-lg-6 form-group">
                            <select
                                class="custom-select form-control"
                                :class="{
                                    'is-invalid':
                                        $v.projectInfo.development_stage.$error
                                }"
                                @focus="showHideLabel('development_stage')"
                                @blur="showHideLabel('development_stage')"
                                v-model.trim="
                                    $v.projectInfo.development_stage.$model
                                "
                                required
                            >
                                <option
                                    :value="null"
                                    selected
                                    disabled
                                    class="custom-select-placeholder"
                                >
                                    {{ $t("development_stage") }} *
                                </option>
                                <option
                                    v-for="option in developmentStageSelect.options"
                                    :value="option.option_ita"
                                    :key="option.option_ita"
                                >
                                    {{ option.option }}
                                </option>
                            </select>
                            <small
                                id="development_stage_label"
                                style="display: none"
                                class="mt-2"
                                >{{ $t("development_stage") }} *</small
                            >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-lg-12 form-group">
                            <textarea
                                type="text"
                                class="form-control"
                                id="short_description"
                                :class="{
                                    'is-invalid':
                                        $v.projectInfo.project_in_short_words
                                            .$error
                                }"
                                :placeholder="
                                    $t('project_in_short_words') + ' *'
                                "
                                onfocus="this.placeholder=''"
                                onblur="this.placeholder='Il progetto in poche parole *'"
                                @focus="showHideLabel('project_in_short_words')"
                                @blur="showHideLabel('project_in_short_words')"
                                v-model.trim="
                                    $v.projectInfo.project_in_short_words.$model
                                "
                                required
                            >
                            </textarea>
                            <small
                                id="project_in_short_words_label"
                                style="display: none"
                                class="mt-2"
                                >{{ $t("project_in_short_words") }} *</small
                            >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-lg-12 form-group">
                            <textarea
                                type="text"
                                class="form-control"
                                id="description"
                                :class="{
                                    'is-invalid':
                                        $v.projectInfo.description.$error
                                }"
                                :placeholder="$t('project_description') + ' *'"
                                rows="4"
                                onfocus="this.placeholder=''"
                                onblur="this.placeholder='Descrizione del progetto *'"
                                @focus="showHideLabel('description')"
                                @blur="showHideLabel('description')"
                                v-model.trim="$v.projectInfo.description.$model"
                                required
                            >
                            </textarea>
                            <small
                                id="description_label"
                                style="display: none"
                                class="mt-2"
                                >{{ $t("project_description") }} *</small
                            >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-lg-9 form-group">
                            <div class="input-group row ml-0">
                                    <div class="custom-file">
                                        <input
                                            id="documentation"
                                            style="cursor: pointer"
                                            accept=".pdf"
                                            type="file"
                                            class="custom-file-input"
                                            v-on:change="
                                                handleFileUpload(
                                                    'documentation',
                                                    'DOC'
                                                )
                                            "
                                            ref="documentation"
                                        />
                                        <label
                                            v-show="
                                                !projectInfo.files
                                                    .documentation
                                            "
                                            class="custom-file-label"
                                            for="inputGroupFile02"
                                            >{{
                                                $t("upload_documentation")
                                            }}</label
                                        >
                                        <label
                                            v-show="
                                                projectInfo.files
                                                    .documentation
                                            "
                                            class="custom-file-label"
                                            for="inputGroupFile02"
                                            >{{
                                                projectInfo.files
                                                    .documentation
                                            }}</label
                                        >
                                    </div>
                                    <div
                                        class="input-group-append custom-file-button bg-yellow mr-5"
                                    >
                                        <span
                                            v-show="
                                                !projectInfo.files
                                                    .documentation
                                            "
                                            class="custom-file-text text-white"
                                            >{{ $t("upload") }}</span
                                        >
                                        <span
                                            v-on:click="
                                                openDeleteModal(
                                                    'documentation'
                                                )
                                            "
                                            v-show="
                                                projectInfo.files
                                                    .documentation
                                            "
                                            class="custom-file-text text-white"
                                            style="cursor: pointer"
                                            >{{ $t("delete") }}</span
                                        >
                                    </div>
                                    <i
                                        v-show="
                                            !projectInfo.files
                                                .documentation &&
                                                !loading_documentation
                                        "
                                        class="tio-done file-upload-icon"
                                        style="color: transparent"
                                    ></i>
                                    <i
                                        v-show="
                                            projectInfo.files.documentation
                                        "
                                        class="tio-done file-upload-icon"
                                        style="color: #9ac288"
                                    ></i>
                                    <i
                                        v-show="file_error"
                                        class="tio-clear file-upload-icon"
                                        style="color: #ff5b1e"
                                    ></i>
                                    <i
                                        v-show="loading_documentation"
                                        class="tio-autorenew file-loading-icon rotating"
                                        style="color: #ababab"
                                    ></i>
                                </div>
                                <small
                                    v-show="projectInfo.files.documentation"
                                    class="mt-2"
                                    >{{
                                        $t("upload_documentation")
                                    }}
                                    *</small
                                >


                            <div class="mb-3"></div>
                        </div>
                    </div>

                    <div class="form-row mb-20">
                        <div class="col-lg-12 form-group">
                            <custom-checkbox
                                v-model="has_company"
                            >
                                {{ $t("company_started") }}
                            </custom-checkbox>
                        </div>
                        <template v-if="has_company">
                            <div class="col-lg-12 form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="{
                                        'is-invalid':
                                            $v.projectInfo.company_vat.$error
                                    }"
                                    :placeholder="$t('company_vat') + ' *'"
                                    onfocus="this.placeholder=''"
                                    :onblur="
                                        (this.placeholder =
                                            $t('company_vat') + ' *')
                                    "
                                    @focus="showHideLabel('company_vat')"
                                    @blur="showHideLabel('company_vat')"
                                    v-model.trim="
                                        $v.projectInfo.company_vat.$model
                                    "
                                    required
                                />
                                <small
                                    v-show="projectInfo.company_vat"
                                    id="company_vat_label"
                                    style="display: block"
                                    class="mt-2"
                                    >{{ $t("company_vat") }}*
                                </small>
                            </div>
                            <div class="col-lg-12 form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="{
                                        'is-invalid':
                                            $v.projectInfo
                                                .company_foundation_date.$error
                                    }"
                                    :placeholder="
                                        $t('company_foundation_date') + ' *'
                                    "
                                    onfocus="(this.type='date')"
                                    id="company_foundation_date"
                                    @focus="
                                        showHideLabel('company_foundation_date')
                                    "
                                    @blur="
                                        showHideLabel('company_foundation_date')
                                    "
                                    v-model.trim="
                                        $v.projectInfo.company_foundation_date
                                            .$model
                                    "
                                />
                                <small
                                    id="company_foundation_date_label"
                                    style="display: none"
                                    class="mt-2"
                                    >{{ $t("company_foundation_date") }} *
                                </small>
                            </div>
                            <div class="col-lg-12 form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="{
                                        'is-invalid':
                                            $v.projectInfo.company_start_date
                                                .$error
                                    }"
                                    :placeholder="$t('company_start_date')"
                                    onfocus="(this.type='date')"
                                    id="company_start_date"
                                    @focus="showHideLabel('company_start_date')"
                                    @blur="showHideLabel('company_start_date')"
                                    v-model.trim="
                                        $v.projectInfo.company_start_date.$model
                                    "
                                />
                                <small
                                    id="company_start_date_label"
                                    style="display: none"
                                    class="mt-2"
                                    >{{ $t("company_start_date") }}
                                </small>
                            </div>
                            <div class="col-lg-12 form-group">
                                    <div class="input-group row ml-0">
                                        <div class="custom-file">
                                            <input
                                                id="cameral_visure"
                                                style="cursor: pointer"
                                                accept=".pdf"
                                                type="file"
                                                class="custom-file-input"
                                                v-on:change="
                                                    handleFileUpload(
                                                        'cameral_visure',
                                                        'CV'
                                                    )
                                                "
                                                ref="cameral_visure"
                                            />
                                            <label
                                                v-show="
                                                    !projectInfo.files.cameral_visure
                                                "
                                                class="custom-file-label"
                                                for="inputGroupFile03"
                                                >{{
                                                    $t("upload_cameral_visure")
                                                }}</label
                                            >
                                            <label
                                                v-show="
                                                    projectInfo.files.cameral_visure
                                                "
                                                class="custom-file-label"
                                                for="inputGroupFile03"
                                                >{{
                                                    projectInfo.files.cameral_visure
                                                }}</label
                                            >
                                        </div>
                                        <div
                                            class="input-group-append custom-file-button bg-yellow mr-5"
                                        >
                                            <span
                                                v-show="
                                                    !projectInfo.files.cameral_visure
                                                "
                                                class="custom-file-text text-white"
                                                >{{ $t("upload") }}</span
                                            >
                                            <span
                                                v-on:click="
                                                    openDeleteModal('cameral_visure')
                                                "
                                                v-show="
                                                    projectInfo.files.cameral_visure
                                                "
                                                class="custom-file-text text-white"
                                                style="cursor: pointer"
                                                >{{ $t("delete") }}</span
                                            >
                                        </div>
                                        <i
                                            v-show="
                                                !projectInfo.files.cameral_visure &&
                                                    !loading_cameral_visure
                                            "
                                            class="tio-done file-upload-icon"
                                            style="color: transparent"
                                        ></i>
                                        <i
                                            v-show="projectInfo.files.cameral_visure"
                                            class="tio-done file-upload-icon"
                                            style="color: #9ac288"
                                        ></i>
                                        <i
                                            v-show="file_error"
                                            class="tio-clear file-upload-icon"
                                            style="color: #ff5b1e"
                                        ></i>
                                        <i
                                            v-show="loading_cameral_visure"
                                            class="tio-autorenew file-loading-icon rotating"
                                            style="color: #ababab"
                                        ></i>
                                    </div>
                                    <small
                                        v-show="projectInfo.files.cameral_visure"
                                        class="mt-2"
                                        >{{ $t("upload_cameral_visure") }} *</small
                                    >
                                </div>
                            </template>
                    </div>

                    <!-- navigator  -->
                    <div
                        class="p-5 wizard_navigator custom-row justify-content-between justify-content-center text-white font-lato-regular fixed-bottom sticky-bottom-bar"
                        data-offset="-60"
                        style="background-color: #f2b12d"
                    >
                        <div
                            class="font-16px hover-mouse-pointer"
                            @click="previous()"
                        >
                            <i
                                class="tio-arrow-left-circle-outlined font-25px"
                            ></i>
                            {{ $t("back") }}
                        </div>
                        <div
                            class="font-16px hover-mouse-pointer"
                            @click="saveProject()"
                        >
                            {{ $t("forward") }}
                            <i
                                class="tio-arrow-right-circle-outlined font-25px"
                            ></i>
                        </div>
                    </div>
                </div>
                <!-- End Card content-->
            </div>
        </div>

        <div class="col-12 text-center mt-6 stick-up-bottom-element">
            <button v-on:click="saveForLater" class="btn btn-secondary">
                {{ $t("save_and_continue") }}
            </button>
        </div>

        <div
            class="modal fade"
            id="remove_file_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ $t("remove_file") }}
                        </h5>
                        <button
                            type="button"
                            class="btn btn-xs btn-icon btn-ghost-secondary"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <i class="tio-clear tio-lg"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ $t("sure_to_remove_file") }}
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-white"
                            data-dismiss="modal"
                        >
                            {{ $t("cancel") }}
                        </button>
                        <button
                            type="button"
                            @click="removeFile()"
                            class="btn btn-primary"
                        >
                            {{ $t("confirm") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
    name: "ProjectInfo",
    props: [
        "projectProp",
        "route",
        "previousRoute",
        "fileRoute",
        "deleteFileRoute",
        "developmentStageSelect",
        "sectorSelect"
    ],
    mounted() {
    // This can't override my projectInfo
        for (let [key, value] of Object.entries(this.projectProp)) {
            this.projectInfo[key] = value;
        }
        this.projectInfo = this.projectProp;
        this.has_company = this.projectInfo.company_vat != null;
        this.has_company = this.projectInfo.company_vat != null;

        document.getElementById("short_description").maxLength = 300;
        document.getElementById("description").maxLength = 3000;
    },
    data() {
        return {
            changer:0,
            loading_cameral_visure: false,
            loading_documentation: false,

            project: {},
            loading: false,
            file_error: false,
            has_company: false,
            projectInfo: {
                name: null,
                sector: null,
                development_stage: null,
                project_in_short_words: null,
                description: null,
                company_vat: null,
                company_foundation_date: null,
                company_start_date: null,
                documentation: null,
                files: {
                    cameral_visure: null,
                }
            }
        };
    },

    validations() {
        return {
            has_company: { required },
            projectInfo: {
                name: { required },
                sector: { required },
                development_stage: { required },
                project_in_short_words: { required },
                description: { required },
                company_vat: this.has_company ? { required } : {},
                company_foundation_date: this.has_company ? { required } : {},
                company_start_date: {},
                documentation: {},
                files: {
                    cameral_visure: this.has_company ? { required } : {},
                }
            }
        };
    },

    methods: {
        getFileName() {
            if (
                typeof this.projectInfo.documentation != "undefined" &&
                this.projectInfo.documentation
            ) {
                if (
                    typeof this.projectInfo.documentation.name != "undefined" &&
                    this.projectInfo.documentation.name
                ) {
                    return this.projectInfo.documentation.name;
                }
                return this.projectInfo.documentation;
            }
            return null;
        },
        saveForLater() {
            if (this.loading)
                return this.$toasted.error(this.$t("is_uploading"));

            this.$v.$touch();

            this.projectInfo.later = true;

            if (!this.$v.$anyError) {
                axios.post(this.route, this.projectInfo).then(response => {
                    window.location.href = response.data.redirect;
                });
            }
        },
        saveProject() {
            if (this.loading)
                return this.$toasted.error(this.$t("is_uploading"));
            this.$v.$touch();

            if (!this.$v.$anyError) {
                axios.post(this.route, this.projectInfo).then(response => {
                    window.location.href = response.data.redirect;
                });
            }
        },

        previous() {
            if (this.loading)
                return this.$toasted.error(this.$t("is_uploading"));

            window.location.href = this.previousRoute;
        },
        showHideLabel(label) {
            var x = document.getElementById(label + "_label");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                var my_label = "this.projectInfo." + label;

                if (!eval(my_label)) x.style.display = "none";
            }
        },
        handleFileUpload(title, name) {
            if (this.$refs[title].files[0] !== undefined) {
                var self = this;

                this.projectInfo.files[title] = null;

                let formData = new FormData();
                formData.append("file", self.$refs[title].files[0]);
                formData.append("title", title);
                formData.append(
                    "name",
                    "F2_" +
                        this.projectProp.project_id +
                        "_" +
                        name +
                        "_" +
                        self.projectInfo.name +
                        ".pdf"
                );

                let config = {
                    headers: { "Content-Type": "multipart/form-data" }
                };

                this.loading = true;
                this.loaderOn(title);

                axios
                    .post(this.fileRoute, formData, config)
                    .then(response => {
                        this.changer++;
                        this.loading = false;
                        this.loaderOff(title);
                        this.projectInfo.files[title] = this.$refs[
                            title
                        ].files[0].name;
                        this.findError();
                    })
                    .catch(error => {
                        this.loading = false;
                        this.loaderOff(title);
                        if (error.response.data.errors) {
                            this.$toasted.error(this.$t("must_be_pdf"));
                        }
                    });
            }
        },

        openDeleteModal(title) {
            this.tempRemoveTitle = title;
            $("#remove_file_modal").modal();
        },
        removeFile() {
            $("#remove_file_modal").modal("hide");
            this.loaderOn(this.tempRemoveTitle);
            this.projectInfo.files[this.tempRemoveTitle] = null;

            let formData = new FormData();
            formData.append("title", this.tempRemoveTitle);
            //formData.append("media_id", this.projectInfo.files[this.tempRemoveTitle].id);

            this.projectInfo.files[this.tempRemoveTitle] = null;
            axios.post(this.deleteFileRoute, formData).then(response => {
                this.loaderOff(this.tempRemoveTitle);
            });
        },
        loaderOn(title) {
            if (title === "cameral_visure") this.cameral_visure = true;
            if (title === "documentation") this.documentation = true;
        },
        loaderOff(title) {
            if (title === "cameral_visure") this.cameral_visure = false;
            if (title === "documentation") this.documentation = false;
        },
        findError() {
            if (this.$v.projectInfo.files.cameral_visure.$anyError)
                $("#cameral_visure").addClass("is-invalid");
            else $("#cameral_visure").removeClass("is-invalid");
        },
    }
};
</script>

<style scoped>
.bg-yellow {
    background-color: #f2b12d;
}
</style>
